import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=3d3c335a&scoped=true&"
import script from "./RoleModal.vue?vue&type=script&lang=js&"
export * from "./RoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c335a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3c335a')) {
      api.createRecord('3d3c335a', component.options)
    } else {
      api.reload('3d3c335a', component.options)
    }
    module.hot.accept("./RoleModal.vue?vue&type=template&id=3d3c335a&scoped=true&", function () {
      api.rerender('3d3c335a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examples/list/modules/RoleModal.vue"
export default component.exports